const loader = {
  elem: document.querySelector('.saig-m-loader'),
  init: function () {
    this.addEvent();
  },
  addEvent: function () {
    window.addEventListener('showLoader', (event: any) => {
      this.showLoader();
    });

    window.addEventListener('removeLoader', (event: any) => {
      this.removeLoader();
    });
  },
  showLoader: function () {
    this.elem?.classList.remove('display-none');
  },
  removeLoader: function () {
    this.elem?.classList.contains('display-none') ? '' : this.elem?.classList.add('display-none');
  },
};

loader.init();

export { loader };
